import { render, staticRenderFns } from "./res-api-auth.vue?vue&type=template&id=687267ca"
import script from "./res-api-auth.vue?vue&type=script&lang=js"
export * from "./res-api-auth.vue?vue&type=script&lang=js"
import style0 from "./res-api-auth.vue?vue&type=style&index=0&id=687267ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports